import {
    actionServersSetActiveServer,
    actionServersSetEnabledServers,
    actionServersSetServerList,
    actionServersSetProfiles,
    actionLauncherSetReadyState,
    actionVersionsSetClient,
    actionVersionsSetLauncher,
    actionVersionsSetUi,
    actionProcessUpdate,
} from '../../actions'
import attribs from '../../settings/references'
import serv from '../../settings/services'
import { launcherSetToken } from '../../launcherBackend/launcher-command'
import { actions as settingsActions } from '../../features/Settings'
import { actions as toasterActions } from '../../features/Toaster'
import { actions as loadingBarActions } from '../../features/LoadingBar'

export { default as getTexts } from '../../store/localizer'

export const attributes = {
    languages: attribs.languages,
    serviceDomains: {
        testing: attribs.service.domains.testing,
        production: attribs.service.domains.production,
    },
    regex: {
        version: attribs.regex.version,
    },
}

export const tokenServices = {
    test: serv.token_service.test,
    production: serv.token_service.production,
}

export const actions = {
    setActiveServer: actionServersSetActiveServer,
    setEnabledServers: actionServersSetEnabledServers,
    setServerList: actionServersSetServerList,
    setServerProfiles: actionServersSetProfiles,
    setLauncherReady: actionLauncherSetReadyState,
    saveProgress: loadingBarActions.setProgress,
    setProgressMessage: loadingBarActions.setProgressMessage,
    setClientVersion: actionVersionsSetClient,
    setLauncherVersion: actionVersionsSetLauncher,
    setUiVersion: actionVersionsSetUi,
    saveSettings: settingsActions.saveSettings,
    showError: toasterActions.addError,
    updateProcess: actionProcessUpdate,
}

export const commands = {
    launcherSetToken,
}



// WEBPACK FOOTER //
// ./src/features/Backend/imports.js